/**
 * Copyright Mántum All Rights Reserved.
 */
import useEscape from '../../../hooks/useEscape';
import Contained from '../button/contained';
import Text from '../button/text';
import { XMarkIcon } from '@heroicons/react/24/outline';

type PropTypes = {
    isNegative?: boolean;
    loading?: boolean;
    message?: string | React.ReactNode;
    negative?: string;
    onNegative?: () => void;
    onPositive?: () => void;
    positive?: string;
    title?: string;
};

export default function Modal(props: PropTypes) {
    const {
        isNegative = true,
        loading = false,
        negative = 'Cancel',
        positive = 'Accept'
    } = props;

    useEscape(() => {
        if (props.onNegative) {
            props.onNegative();
        }
    });

    return (
        <>
            <div className='fixed inset-0 z-40 bg-gray-500 bg-opacity-75 transition-opacity'></div>
            <div className='fixed inset-0 z-50 overflow-y-auto'>
                <div className='flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0'>
                    <div className='relative transform rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl lg:max-w-3xl'>
                        <div className='bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4'>
                            <div className='sm:flex sm:items-start'>
                                <div className='mt-3 w-full text-center sm:ml-0 sm:mt-0 sm:text-left'>
                                    <div className='flex items-center justify-center sm:justify-between'>
                                        <h3 className='basis-3/4 text-2xl font-medium leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight'>
                                            {props.title}
                                        </h3>
                                        <XMarkIcon
                                            className='hidden h-9 w-9 cursor-pointer rounded-md p-1 text-gray-900 hover:bg-accent sm:block'
                                            onClick={props.onNegative}
                                            title='close'
                                        />
                                    </div>
                                    <div className='mt-6'>
                                        <div className='text-base text-gray-500'>
                                            {props.message}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6'>
                            <div className='text-sm'>
                                <Contained
                                    testid='accept'
                                    onClick={props.onPositive}
                                    loading={loading}
                                >
                                    {positive}
                                </Contained>
                            </div>
                            {isNegative && (
                                <div className='mr-0 mt-2 text-sm sm:mr-2 sm:mt-0'>
                                    <Text
                                        testid='cancel'
                                        onClick={props.onNegative}
                                    >
                                        {negative}
                                    </Text>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
